import { render, staticRenderFns } from "./expensesreport.vue?vue&type=template&id=53ba4e46"
import script from "./expensesreport.vue?vue&type=script&lang=js"
export * from "./expensesreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports